import React from 'react';

import { ButtonWithSpinner } from '@eika/button-with-spinner';

import useTranslation from '../../../../hooks/useTranslation';
import { StickyFooterRow } from '../../../shared/StickyFooter';

interface Props {
    onClickButton: () => void;
    pending: boolean;
    btnText?: string;
}

const SelectReceiverStickyFooter: React.FC<Props> = ({ onClickButton, pending, btnText }) => {
    const translated = useTranslation();

    return (
        <StickyFooterRow>
            <ButtonWithSpinner size="small" buttonType="positive" showSpinner={pending} onClick={onClickButton}>
                {btnText ?? translated.continue}
            </ButtonWithSpinner>
        </StickyFooterRow>
    );
};

export default SelectReceiverStickyFooter;
